export enum PriceCalendarMonthlyActions {
  SLICE_NAME = '@PRICE_CALENDAR_MONTHLY',
  FETCH_MONTHLY_PRICES = '@PRICE_CALENDAR_MONTHLY/FETCH_MONTHLY_PRICES',
  RECEIVE_MONTHLY_PRICES_SUCCESS = '@PRICE_CALENDAR_MONTHLY/RECEIVE_MONTHLY_PRICES_SUCCESS',
  RECEIVE_MONTHLY_EMPTY_PRICES = '@PRICE_CALENDAR_MONTHLY/RECEIVE_MONTHLY_EMPTY_PRICES',
  RECEIVE_MONTHLY_PRICES_FAILURE = '@PRICE_CALENDAR_MONTHLY/RECEIVE_MONTHLY_PRICES_FAILURE',
  CLEAR_MONTHLY = '@PRICE_CALENDAR_MONTHLY/CLEAR_MONTHLY',
  SET_DAY = '@PRICE_CALENDAR_MONTHLY/SET_DAY',
  SET_MONTH = '@PRICE_CALENDAR_MONTHLY/SET_MONTH',
  SET_LOADING = '@PRICE_CALENDAR_MONTHLY/SET_LOADING',
  FETCH_PRICES_ON_FETCH_FILTERS_FULFILLED = '@PRICE_CALENDAR_MONTHLY/FETCH_PRICES_ON_FETCH_FILTERS_FULFILLED'
}

export enum PriceCalendarFilterActions {
  SLICE_NAME = '@PRICE_CALENDAR_FILTERS',
  FETCH_FILTERS = '@PRICE_CALENDAR_FILTERS/FETCH_FILTERS',
  RECEIVE_FILTERS_SUCCESS = '@PRICE_CALENDAR_FILTERS/RECEIVE_FILTERS_SUCCESS',
  RECEIVE_FILTERS_FAILURE = '@PRICE_CALENDAR_FILTERS/RECEIVE_FILTERS_FAILURE',
  SET_FILTERS = '@PRICE_CALENDAR_FILTERS/SET_FILTERS',
  SET_AIRPORT = '@PRICE_CALENDAR_FILTERS/SET_AIRPORT'
}
